/* ============================================================================
   Joe's Kitchen — Dark "Crave" shared chrome behaviour
   Ported from design_handoff_joeskitchen/shared.js, but the prototype's
   localStorage cart is replaced by the real Shopify Ajax Cart API
   (/cart/add.js, /cart/change.js, /cart.js).

   Chrome markup is server-rendered by snippets/jk-chrome.liquid; this file
   hydrates icons, wires the menu + drawer, and renders cart state.
   ============================================================================ */
(function () {
  /* ---- Inline SVG icon registry (currentColor) ---- */
  const ICONS = {
    search: '<svg viewBox="0 0 18 19" fill="currentColor"><path fill-rule="evenodd" d="M11.03 11.68A5.784 5.784 0 1 1 2.85 3.5a5.784 5.784 0 0 1 8.18 8.18m.26 1.12a6.78 6.78 0 1 1 .72-.7l5.4 5.4a.5.5 0 1 1-.71.7z" clip-rule="evenodd"/></svg>',
    cart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M2.5 3.3h2.45l1.86 11.03a1.7 1.7 0 0 0 1.68 1.42h8.18a1.7 1.7 0 0 0 1.67-1.35L19.9 6.6H6.05"/><circle cx="9.1" cy="20.1" r="1.5"/><circle cx="17.7" cy="20.1" r="1.5"/></svg>',
    bag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M5 7.5h14l-1.05 12.1a1.6 1.6 0 0 1-1.6 1.4H7.65a1.6 1.6 0 0 1-1.6-1.4z"/><path d="M8.5 7.5V6a3.5 3.5 0 0 1 7 0v1.5"/></svg>',
    close: '<svg viewBox="0 0 18 17" fill="currentColor"><path d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"/></svg>',
    plus: '<svg viewBox="0 0 10 10" fill="currentColor"><path fill-rule="evenodd" d="M1 4.51a.5.5 0 0 0 0 1h3.5l.01 3.5a.5.5 0 0 0 1-.01V5.5l3.5-.01a.5.5 0 0 0-.01-1H5.5L5.49.99a.5.5 0 0 0-1 .01v3.5l-3.5.01z" clip-rule="evenodd"/></svg>',
    minus: '<svg viewBox="0 0 10 2" fill="currentColor"><path fill-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 1 1 0 1H1A.5.5 0 0 1 .5 1" clip-rule="evenodd"/></svg>',
    arrow: '<svg viewBox="0 0 14 10" fill="currentColor"><path fill-rule="evenodd" d="M8.537.808a.5.5 0 0 1 .817-.162l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 1 1-.708-.708L11.793 5.5H1a.5.5 0 0 1 0-1h10.793L8.646 1.354a.5.5 0 0 1-.109-.546" clip-rule="evenodd"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>',
    instagram: '<svg viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M13.23 3.492c-.84-.037-1.096-.046-3.23-.046-2.144 0-2.39.01-3.238.055-.776.027-1.195.164-1.487.273a2.4 2.4 0 0 0-.912.593 2.5 2.5 0 0 0-.602.922c-.11.282-.238.702-.274 1.486-.046.84-.046 1.095-.046 3.23s.01 2.39.046 3.229c.004.51.097 1.016.274 1.495.145.365.319.639.602.913.282.282.538.456.92.602.474.176.974.268 1.479.273.848.046 1.103.046 3.238.046s2.39-.01 3.23-.046c.784-.036 1.203-.164 1.486-.273.374-.146.648-.329.921-.602.283-.283.447-.548.602-.922.177-.476.27-.979.274-1.486.037-.84.046-1.095.046-3.23s-.01-2.39-.055-3.229c-.027-.784-.164-1.204-.274-1.495a2.4 2.4 0 0 0-.593-.913 2.6 2.6 0 0 0-.92-.602c-.284-.11-.703-.237-1.488-.273ZM6.697 2.05c.857-.036 1.131-.045 3.302-.045a63 63 0 0 1 3.302.045c.664.014 1.321.14 1.943.374a4 4 0 0 1 1.414.922c.41.397.728.88.93 1.414.23.622.354 1.279.365 1.942C18 7.56 18 7.824 18 10.005c0 2.17-.01 2.444-.046 3.292-.036.858-.173 1.442-.374 1.943-.2.53-.474.976-.92 1.423a3.9 3.9 0 0 1-1.415.922c-.51.191-1.095.337-1.943.374-.857.036-1.122.045-3.302.045-2.171 0-2.445-.009-3.302-.055-.849-.027-1.432-.164-1.943-.364a4.15 4.15 0 0 1-1.414-.922 4.1 4.1 0 0 1-.93-1.423c-.183-.51-.329-1.085-.365-1.943C2.009 12.45 2 12.167 2 10.004c0-2.161 0-2.435.055-3.302.027-.848.164-1.432.365-1.942a4.4 4.4 0 0 1 .92-1.414 4.2 4.2 0 0 1 1.415-.93c.51-.183 1.094-.33 1.943-.366Zm.427 4.806a4.105 4.105 0 1 1 5.805 5.805 4.105 4.105 0 0 1-5.805-5.805m1.882 5.371a2.668 2.668 0 1 0 2.042-4.93 2.668 2.668 0 0 0-2.042 4.93m5.922-5.942a.958.958 0 1 1-1.355-1.355.958.958 0 0 1 1.355 1.355" clip-rule="evenodd"/></svg>',
    pin: '<svg viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="m9.91 18.59 5.036-8.78c2.228-3.886-.525-8.777-4.942-8.777-4.385 0-7.147 4.822-4.992 8.713zM10.004 0C4.845 0 1.593 5.673 4.13 10.255l5.212 9.41a.64.64 0 0 0 1.12.009l5.358-9.342C18.445 5.755 15.202 0 10.004 0"/><path d="M13 6.796c0 1.76-1.399 3.187-3.124 3.187S6.752 8.556 6.752 6.796s1.399-3.187 3.124-3.187S13 5.036 13 6.796M9.876 8.949c1.166 0 2.11-.964 2.11-2.153s-.944-2.153-2.11-2.153-2.11.964-2.11 2.153.944 2.153 2.11 2.153"/></svg>',
    fire: '<svg viewBox="0 0 20 20" fill="currentColor"><path d="m10.289.196-.272.419-.284-.412a.5.5 0 0 1 .556-.007m-.265 1.028-.056.041A31.4 31.4 0 0 0 6.36 4.368c-.987.995-1.96 2.135-2.685 3.328-.727 1.198-1.181 2.413-1.181 3.569 0 4.807 3.892 7.524 7.376 7.618 3.464.093 7.636-2.675 7.636-7.711 0-1.218-.454-2.458-1.176-3.653-.72-1.194-1.688-2.313-2.67-3.28a28.6 28.6 0 0 0-3.586-2.98zm7.162 5.778c.777 1.286 1.32 2.706 1.32 4.17 0 5.686-4.729 8.816-8.663 8.71-3.915-.105-8.35-3.164-8.35-8.617 0-1.41.55-2.807 1.327-4.088.78-1.284 1.811-2.486 2.83-3.513A32.4 32.4 0 0 1 9.707.22l.019-.013.005-.004.002-.001.284.412.272-.42.002.002.005.003.02.013a10 10 0 0 1 .33.226 29.6 29.6 0 0 1 3.717 3.088c1.016 1.001 2.045 2.186 2.823 3.475"/><path d="m10.298 6.54-.288.408-.3-.401a.5.5 0 0 1 .588-.008m-.28 1.038A19.6 19.6 0 0 0 7.93 9.54c-.597.652-1.183 1.396-1.617 2.173-.436.779-.702 1.56-.702 2.293 0 3.136 2.146 4.88 4.301 4.88 2.18 0 4.477-1.677 4.477-4.942 0-1.572-1.097-3.197-2.305-4.49a18 18 0 0 0-2.066-1.876m2.797 1.194c1.23 1.317 2.574 3.19 2.574 5.172 0 3.84-2.767 5.941-5.477 5.941-2.734 0-5.3-2.217-5.3-5.88 0-.966.346-1.918.828-2.78.485-.867 1.124-1.674 1.752-2.36A20.6 20.6 0 0 1 9.65 6.592l.044-.033.012-.01.003-.002.002-.001.3.4.287-.408.002.001.003.003.012.008.045.032.162.121a19 19 0 0 1 2.293 2.068"/></svg>',
    truck: '<svg viewBox="0 0 20 20" fill="currentColor"><path d="M0 3.752c0-.277.224-.502.5-.502h10.147a.5.5 0 0 1 .5.502v9.91l-.595 1.003H7.223V13.66h2.923V4.253H1.002v9.408h1.682v1.004H.501A.5.5 0 0 1 0 14.163zm18.999 4.332-7.851-1.975V5.075l8.473 2.131a.5.5 0 0 1 .379.487v6.47a.5.5 0 0 1-.5.502h-2.193v-1.003H19zm-7.851 5.578h2.196v1.003h-2.792z"/><path d="M7.713 14.185a2.56 2.56 0 0 1-2.56 2.565 2.56 2.56 0 0 1-2.56-2.565 2.56 2.56 0 0 1 2.56-2.564 2.56 2.56 0 0 1 2.56 2.564m-2.56 1.562a1.56 1.56 0 0 0 1.558-1.562 1.56 1.56 0 0 0-1.559-1.56 1.56 1.56 0 0 0-1.558 1.56 1.56 1.56 0 0 0 1.558 1.562m12.368-1.562a2.56 2.56 0 0 1-2.56 2.565 2.56 2.56 0 0 1-2.56-2.565 2.56 2.56 0 0 1 2.56-2.564 2.56 2.56 0 0 1 2.56 2.564m-2.56 1.562a1.56 1.56 0 0 0 1.558-1.562 1.56 1.56 0 0 0-1.559-1.56 1.56 1.56 0 0 0-1.558 1.56 1.56 1.56 0 0 0 1.558 1.562"/></svg>',
    star: '<svg viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="m10 2.626-1.46 4.71c-.192.62-.743 1.041-1.365 1.041H2.453l3.82 2.91a1.55 1.55 0 0 1 .522 1.685l-1.46 4.71 3.821-2.911a1.38 1.38 0 0 1 1.688 0l3.82 2.91-1.459-4.71c-.192-.62.019-1.3.522-1.683l3.82-2.911h-4.722c-.622 0-1.173-.42-1.366-1.04zm.455-1.78a.472.472 0 0 0-.91 0L7.63 7.027a.48.48 0 0 1-.455.347H.98c-.464 0-.657.622-.282.908l5.012 3.82a.52.52 0 0 1 .174.56l-1.914 6.18c-.143.462.361.847.736.56l5.013-3.818a.46.46 0 0 1 .562 0l5.013 3.819c.375.286.88-.099.736-.561l-1.914-6.18a.52.52 0 0 1 .174-.56l5.012-3.82c.375-.286.182-.908-.282-.908h-6.195a.48.48 0 0 1-.455-.347z"/></svg>',
    stopwatch: '<svg viewBox="0 0 20 20" fill="currentColor"><path d="M18.701 11.396a8.472 8.472 0 1 1-16.943 0 8.472 8.472 0 0 1 16.943 0m-8.471 7.472a7.472 7.472 0 1 0 0-14.944 7.472 7.472 0 0 0 0 14.944"/><path fill-rule="evenodd" d="M10.72 1.778h-.98a1 1 0 0 0-1 1v.147h2.98v-.147a1 1 0 0 0-1-1m-.98-1a2 2 0 0 0-2 2v1.147h4.98V2.778a2 2 0 0 0-2-2z"/><path d="M8.984 11.396a1.245 1.245 0 1 1 2.491 0 1.245 1.245 0 0 1-2.49 0"/><path d="M9.73 11.396a.5.5 0 0 1 .5-.5h4.98a.5.5 0 1 1 0 1h-4.98a.5.5 0 0 1-.5-.5m.5-5.481a.5.5 0 0 1 .5.5v2.49a.5.5 0 1 1-1 0v-2.49a.5.5 0 0 1 .5-.5m3.724 1.392a.5.5 0 0 1 0 .707l-1.76 1.761a.5.5 0 0 1-.708-.707l1.761-1.761a.5.5 0 0 1 .707 0"/></svg>',
    heart: '<svg viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 5.24 8.515 3.773a4.433 4.433 0 0 0-6.21 0 4.293 4.293 0 0 0 0 6.128L10 17.495l7.695-7.593a4.293 4.293 0 0 0 0-6.128 4.433 4.433 0 0 0-6.21 0zm.765-2.177c2.113-2.084 5.538-2.084 7.65 0a5.29 5.29 0 0 1 0 7.55l-7.695 7.593a1.03 1.03 0 0 1-1.44 0l-7.696-7.594a5.29 5.29 0 0 1 0-7.549C3.697.98 7.122.98 9.234 3.063l.766.755z"/></svg>',
    dish: '<svg viewBox="0 0 20 20" fill="currentColor"><path d="M10 7.229c-4.164 0-7.558 3.453-7.558 7.736a.5.5 0 0 1-1 0c0-4.815 3.821-8.736 8.558-8.736s8.558 3.921 8.558 8.736a.5.5 0 0 1-1 0c0-4.283-3.394-7.736-7.558-7.736"/><path d="M.473 14.987a.5.5 0 0 1 .5-.5h18.054a.5.5 0 1 1 0 1H.973a.5.5 0 0 1-.5-.5m5.62-5.085a.25.25 0 0 1-.119.333c-.46.219-1.449 1.029-1.54 2.459a.25.25 0 1 1-.5-.032c.107-1.658 1.247-2.604 1.826-2.879a.25.25 0 0 1 .333.12"/><path fill-rule="evenodd" d="M10.49 5.048h-.98a1 1 0 0 0-1 1v.147h2.98v-.147a1 1 0 0 0-1-1m-.98-1a2 2 0 0 0-2 2v1.147h4.98V6.048a2 2 0 0 0-2-2z"/></svg>',
    pepper: '<svg viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M13.87.566a.5.5 0 0 1 .5-.5h1.793a.5.5 0 0 1 .5.5v1.435a4 4 0 0 1 .573.327c.226.158.391.321.574.508.578.59.874 1.23.771 1.76a.83.83 0 0 1-.499.632c-.16 3.284-1.218 5.937-3.058 8.155-1.92 2.315-4.666 4.128-8.053 5.709-1.132.528-2.31.824-3.296.836-.94.01-1.92-.245-2.298-1.084-.203-.447-.265-.879-.113-1.297.143-.394.446-.69.764-.941.233-.184.52-.379.828-.587l.338-.23c.443-.304.937-.661 1.463-1.119q.397-.345.815-.7c.93-.793 1.918-1.636 2.8-2.566 1.144-1.207 2.053-2.505 2.388-3.931.041-.174.064-.387.088-.652l.009-.105c.02-.23.042-.488.081-.746a3.7 3.7 0 0 1 .342-1.138 1 1 0 0 1-.085-.094c-.217-.28-.19-.644-.119-.946.08-.334.311-.61.546-.82.244-.22.55-.418.866-.583a5.4 5.4 0 0 1 1.482-.52zm3.663 3.57c-.066-.148-.194-.352-.438-.6a3 3 0 0 0-.431-.388c-.147-.103-.345-.211-.703-.37a.5.5 0 0 1-.298-.457V1.066h-.793v1.255a.5.5 0 0 1-.5.5c-.376 0-.976.173-1.52.456-.266.138-.495.29-.66.439-.12.107-.184.192-.215.248q.139-.076.299-.144c.412-.173.878-.084 1.231.074.362.163.723.45.917.836.087.175.264.262.564.222.147-.02.291-.068.406-.13a.6.6 0 0 0 .161-.116c.196-.34.569-.564.935-.656.316-.08.695-.078 1.044.087"/></svg>',
    leaf: '<svg viewBox="0 0 20 20" fill="currentColor"><path d="M18.63.085c.291.058.627.167.869.398.25.24.363.581.421.873.062.307.08.648.08.97a14 14 0 0 1-.099 1.443l-.012.11v.006a67 67 0 0 1-.633 4.278c-.298 1.612-.694 3.382-1.214 4.954v.003c-.502 1.494-1.207 3.11-2.254 4.158-3.607 3.612-9.47 3.639-13.081.024-3.61-3.616-3.584-9.487.023-13.099C3.777 3.155 5.378 2.45 6.884 1.946h.001c1.57-.52 3.325-.917 4.948-1.215a66 66 0 0 1 4.273-.634h.005l.038-.005A14 14 0 0 1 17.665 0c.32.003.66.024.966.085m-2.41 1.018c-1.106.13-2.61.33-4.204.623-1.6.294-3.304.68-4.813 1.18-1.478.494-2.886 1.14-3.758 2.013C.229 8.14.209 13.37 3.421 16.586s8.436 3.196 11.652-.024c.871-.872 1.517-2.293 2.01-3.764.499-1.51.885-3.228 1.179-4.818a66 66 0 0 0 .635-4.327c.035-.314.09-.824.092-1.33 0-.289-.017-.554-.06-.767-.046-.229-.106-.32-.129-.341-.03-.03-.134-.09-.367-.137a4.3 4.3 0 0 0-.775-.066 13 13 0 0 0-1.408.088z"/><path d="M19.43.502a.507.507 0 0 1-.004.715L.861 19.617a.505.505 0 1 1-.711-.72L18.715.498a.505.505 0 0 1 .715.004"/><path d="M5.623 2.477h.505v11.19h11.268v.505H5.623z"/><path d="M10.188 1.188h.505v7.96h8.091v.505h-8.596z"/></svg>',
  };
  const ic = (name) => `<span class="mask">${ICONS[name] || ''}</span>`;
  function hydrateIcons(root) {
    (root || document).querySelectorAll('[data-icon]').forEach((el) => {
      if (!el.firstElementChild) el.innerHTML = ICONS[el.dataset.icon] || '';
    });
  }
  window.JKIcon = ic;
  window.JKHydrate = hydrateIcons;

  /* ----------------------------------------------------------- HELPERS */
  const $ = (id) => document.getElementById(id);
  const routes = window.routes || {};
  const moneyFmt = (cents) => {
    const fmt = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: fmt }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  };

  /* ------------------------------------------------------------- CART */
  let CART = { item_count: 0, items: [], total_price: 0, items_subtotal_price: 0 };
  const FREE_DELIVERY_CENTS = 10000; // $100 threshold (display only — confirm vs shipping settings)
  const FLAT_DELIVERY_CENTS = 800;   // $8 flat (display only)

  function fetchCart() {
    return fetch(`${routes.cart_url || '/cart'}.js`, { headers: { 'Content-Type': 'application/json' } })
      .then((r) => r.json())
      .then((c) => { CART = c; return c; });
  }

  function lineOpt(item) {
    const parts = [];
    (item.options_with_values || []).forEach((o) => {
      if (o.value && o.value !== 'Default Title') parts.push(o.value);
    });
    const props = item.properties || {};
    Object.keys(props).forEach((k) => {
      if (k.charAt(0) !== '_' && props[k]) parts.push(props[k]);
    });
    return parts.join(' · ');
  }

  function renderCart(added) {
    const count = CART.item_count || 0;
    const subtotal = CART.items_subtotal_price != null ? CART.items_subtotal_price : CART.total_price;

    const pip = $('jkCartPip');
    if (pip) { pip.textContent = count; pip.classList.toggle('show', count > 0); }
    const fabPip = $('jkFabPip');
    if (fabPip) { fabPip.textContent = count; fabPip.classList.toggle('show', count > 0); }

    const bar = $('jkCartBar');
    if (bar) {
      const t = $('jkCbText');
      if (t) t.innerHTML = `<strong>${count}</strong> item${count !== 1 ? 's' : ''} in order`;
      const p = $('jkCbPrice');
      if (p) p.textContent = moneyFmt(subtotal);
      if (count > 0) {
        bar.classList.add('visible');
        if (added) { bar.classList.remove('bump'); void bar.offsetWidth; bar.classList.add('bump'); }
      } else {
        bar.classList.remove('visible');
        closeDrawer();
      }
    }

    const body = $('jkCdBody');
    const foot = $('jkCdFoot');
    if (!body || !foot) return;
    if (!CART.items || CART.items.length === 0) {
      body.innerHTML = `<div class="cd-empty"><div class="ico">${ic('cart')}</div>Your order is empty.<br>Choose a dish to get started.</div>`;
      foot.innerHTML = '';
    } else {
      body.innerHTML = CART.items.map((l) => {
        const opt = lineOpt(l);
        const img = l.image ? l.image : '';
        return `
        <div class="cd-line" data-key="${l.key}">
          <div class="cd-line-img">${img ? `<img src="${img}" alt="" loading="lazy">` : ''}</div>
          <div class="cd-line-info">
            <div class="cd-line-name">${l.product_title || l.title}</div>
            ${opt ? `<div class="cd-line-opt">${opt}</div>` : ''}
            <div class="cd-stepper">
              <button data-act="dec" data-key="${l.key}" aria-label="Decrease quantity">${ic('minus')}</button>
              <span class="q">${l.quantity}</span>
              <button data-act="inc" data-key="${l.key}" aria-label="Increase quantity">${ic('plus')}</button>
            </div>
          </div>
          <div class="cd-line-price">${moneyFmt(l.final_line_price)}</div>
        </div>`;
      }).join('');
      const delivery = subtotal >= FREE_DELIVERY_CENTS ? 0 : FLAT_DELIVERY_CENTS;
      foot.innerHTML = `
        <div class="cd-row"><span>Subtotal</span><span>${moneyFmt(subtotal)}</span></div>
        <div class="cd-row"><span>Delivery</span><span>${delivery === 0 ? 'Free' : moneyFmt(delivery)}</span></div>
        <div class="cd-row total"><span class="l">Total</span><span class="v">${moneyFmt(subtotal + delivery)}</span></div>
        <button class="cd-checkout" id="jkCheckout">Go to Cart</button>
        <div class="cd-note">Free local delivery on orders over ${moneyFmt(FREE_DELIVERY_CENTS)}</div>`;
      body.querySelectorAll('.cd-stepper button').forEach((b) => {
        b.addEventListener('click', () => {
          const line = CART.items.find((x) => x.key === b.dataset.key);
          if (!line) return;
          const next = line.quantity + (b.dataset.act === 'inc' ? 1 : -1);
          changeQty(b.dataset.key, Math.max(0, next));
        });
      });
      const co = $('jkCheckout');
      if (co) co.addEventListener('click', () => { window.location.href = routes.cart_url || '/cart'; });
    }
    window.dispatchEvent(new CustomEvent('jk-cart-change', { detail: { cart: CART } }));
  }

  function addToCart(variantId, quantity, properties) {
    const payload = { id: variantId, quantity: quantity || 1 };
    if (properties && Object.keys(properties).length) payload.properties = properties;
    return fetch(routes.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [payload] }),
    })
      .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
      .then(({ ok, data }) => {
        if (!ok) throw new Error((data && data.description) || 'Could not add to cart');
        return fetchCart().then(() => { renderCart(true); return data; });
      });
  }

  function addBulk(items) {
    // items: [{ id, quantity, properties? }] — added in a single /cart/add.js request
    const payload = (items || [])
      .filter((it) => it && it.id && (it.quantity || 0) > 0)
      .map((it) => {
        const o = { id: it.id, quantity: it.quantity };
        if (it.properties && Object.keys(it.properties).length) o.properties = it.properties;
        return o;
      });
    if (!payload.length) return Promise.resolve(null);
    return fetch(routes.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: payload }),
    })
      .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
      .then(({ ok, data }) => {
        if (!ok) throw new Error((data && data.description) || 'Could not add to cart');
        return fetchCart().then(() => { renderCart(true); return data; });
      });
  }

  function changeQty(key, quantity) {
    return fetch(routes.cart_change_url || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    })
      .then((r) => r.json())
      .then((c) => { CART = c; renderCart(false); return c; });
  }

  function openDrawer() {
    const d = $('jkCartDrawer'); const s = $('jkCartScrim');
    if (!d) return;
    d.classList.add('open');
    if (s) s.classList.add('open');
    document.body.classList.add('no-scroll');
  }
  function closeDrawer() {
    $('jkCartDrawer') && $('jkCartDrawer').classList.remove('open');
    $('jkCartScrim') && $('jkCartScrim').classList.remove('open');
    if (!document.body.classList.contains('menu-open')) document.body.classList.remove('no-scroll');
  }

  /* Public API used by page-level section scripts */
  window.JK = {
    add: addToCart,
    addBulk,
    changeQty,
    openDrawer,
    refresh: () => fetchCart().then(() => renderCart(false)),
    getCart: () => CART,
    icon: ic,
    money: moneyFmt,
  };

  /* -------------------------------------------------------- MENU CURTAIN */
  function setMenu(open) {
    document.body.classList.toggle('menu-open', open);
    document.body.classList.toggle('no-scroll', open);
  }
  function wireMenu() {
    const trigger = $('jkMenuTrigger');
    if (trigger) trigger.addEventListener('click', () => setMenu(!document.body.classList.contains('menu-open')));
    const scrim = $('jkCurtainScrim');
    if (scrim) scrim.addEventListener('click', () => setMenu(false));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { setMenu(false); closeDrawer(); } });
  }

  function goToCart() { window.location.href = routes.cart_url || '/cart'; }

  function wireCart() {
    // Header cart icon + floating "Review Order" → full cart page.
    const cartBtn = $('jkCartBtn');
    if (cartBtn) cartBtn.addEventListener('click', goToCart);
    const review = $('jkCbReview');
    if (review) review.addEventListener('click', goToCart);
    // Persistent right-side button → quick-edit drawer.
    const fab = $('jkCartFab');
    if (fab) fab.addEventListener('click', openDrawer);
    const close = $('jkCdClose');
    if (close) close.addEventListener('click', closeDrawer);
    const scrim = $('jkCartScrim');
    if (scrim) scrim.addEventListener('click', closeDrawer);
  }

  /* ----------------------------------------------------- HEADER + SCROLL */
  function wireHeader() {
    const header = document.querySelector('.site-header');
    if (!header) return;
    const onScroll = () => header.classList.toggle('solid', window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  function wireReveals() {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal, .reveal-img').forEach((el) => io.observe(el));
    window.JKObserveReveals = (els) => els.forEach((el) => io.observe(el));
  }

  function applyVary() {
    if (document.querySelector('.hero')) document.body.dataset.hero = '2';
    document.body.dataset.cart = 'pill';
  }

  /* --------------------------------------------------------------- INIT */
  function init() {
    hydrateIcons(document);
    applyVary();
    wireMenu();
    wireCart();
    wireHeader();
    wireReveals();
    fetchCart().then(() => renderCart(false)).catch(() => renderCart(false));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
